module.exports = __webpack_public_path__ + "media/bgmusic.a66b64f8.mp3";